module.exports = __webpack_public_path__ + "img/blue-success-feedback.e1f1c1eb.gif";